/**
 * Local-only dev testing affordances (the onboarding harness). Gated by the
 * VITE_DEV_TOOLS build flag — off by default, turned on only by the local
 * docker-compose. Even if it leaked into a deployed build, the endpoints behind
 * it are DEV_SEED_ENABLED-only and 404 in production, so it's inert there.
 */
export const DEV_TOOLS = import.meta.env.VITE_DEV_TOOLS === 'true';
